/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Profile_AvatarInputs */

const cs_settings_profile_avatar = /** @type {(inputs: Settings_Profile_AvatarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změnit fotografii`)
};

const en_settings_profile_avatar = /** @type {(inputs: Settings_Profile_AvatarInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change photo`)
};

/**
* | output |
* | --- |
* | "Change photo" |
*
* @param {Settings_Profile_AvatarInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_profile_avatar = /** @type {((inputs?: Settings_Profile_AvatarInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Profile_AvatarInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_profile_avatar(inputs)
	return cs_settings_profile_avatar(inputs)
});